export const baseAPIUrl = process.env.NEXT_PUBLIC_API_ENDPOINT;
export const baseClientUrl = process.env.NEXT_PUBLIC_APP_HOST;
export const robotsTxt =
  "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1";
